import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * StepSuccess — the final cinematic ‘thank you’ surface. Reset flow so
 * users can start a new inquiry.
 */
export const StepSuccess = ({ inquiryId, onStartAnother }) => (
    <motion.section
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1] }}
        className="flex flex-col items-center py-16 text-center"
        data-testid="step-success"
    >
        <motion.div
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="flex h-24 w-24 items-center justify-center rounded-full"
            style={{ background: "var(--pg-accent)", color: "#071112", boxShadow: "0 24px 60px color-mix(in srgb, var(--pg-accent) 30%, transparent)" }}
        >
            <CheckCircle2 className="h-11 w-11" strokeWidth={1.6} />
        </motion.div>

        <span className="pg-eyebrow mt-8 inline-block" data-testid="success-eyebrow">Consultation received</span>
        <h2
            className="font-display mt-4 text-[clamp(2.2rem,4.4vw,3.4rem)] leading-[1.05]"
            style={{ color: "var(--pg-fg)" }}
            data-testid="success-headline"
        >
            Thank you.
        </h2>
        <p className="mt-5 max-w-md text-base leading-relaxed" style={{ color: "var(--pg-fg-muted)" }}>
            Your project brief has landed in Pranto's inbox. Expect a personal reply within
            24 hours on business days.
        </p>

        {inquiryId && (
            <div
                className="mt-6 inline-flex items-center gap-2 rounded-full border px-3 py-1.5"
                style={{ borderColor: "var(--pg-border)", background: "var(--pg-surface)" }}
                data-testid="success-inquiry-id"
            >
                <span className="text-[11px] font-medium tracking-normal" style={{ color: "var(--pg-fg-muted)" }}>
                    Ref
                </span>
                <span className="font-mono text-[11px]" style={{ color: "var(--pg-fg)" }}>
                    {inquiryId.slice(0, 8).toUpperCase()}
                </span>
            </div>
        )}

        <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row">
            <Link
                to="/"
                data-testid="success-back-home"
                className="pg-btn-primary"
            >
                Back to Pranto.Gfx <ArrowRight className="h-4 w-4" />
            </Link>
            <button
                type="button"
                onClick={onStartAnother}
                data-testid="success-start-another"
                className="pg-btn-ghost"
            >
                Start another inquiry
            </button>
        </div>
    </motion.section>
);

export default StepSuccess;
